export default "__VITE_ASSET__1720dfd4__"